import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import * as actions from '../../actions'
import {
  IngresoCompleto0,
  IngresoCompleto1,
  IngresoCompleto2,
  IngresoCompleto3
} from './steps'
import { FORM_INGRESO_COMPLETO } from '../../../../config/forms'
import { toast } from 'react-toastify'
import ModalSinCupo from './ModalSinCupo'
// import validateIngresoCompleto from '../../../Forms/validateIngresoCompleto'

const selector = formValueSelector(FORM_INGRESO_COMPLETO)

class IngresoCompleto extends Component {
  constructor (props) {
    super(props)
    this.nextStep = this.nextStep.bind(this)
    this.prevStep = this.prevStep.bind(this)
    this.resetStep = this.resetStep.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  nextStep () {
    const {
      iCompletoStep,
      numero,
      codigoCupo,
      verificarCupo,
      confirmarArribo,
      submitIngresoCompleto,
      actualizarPresunta
      // setActualizarPresunta
    } = this.props

    if (iCompletoStep === 0) {
      if (numero && isNaN(numero) && !codigoCupo) {
        toast.error('El número ingresado no es válido')
      } else {
        // if (codigoCupo) {
        //   setActualizarPresunta(true)
        // }
        // verificarCupo(numero, codigoCupo)
        verificarCupo(numero)
      }
    } else if (iCompletoStep === 1) {
      if (actualizarPresunta) {
        this.props.completoNextStep()
      } else {
        confirmarArribo(numero)
      }
    } else if (iCompletoStep === 2) {
      // if (actualizarPresunta && codigoCupo) {
      //   actualizarPresunta(codigoCupo)
      // } else {
      submitIngresoCompleto()
      // }
    }
  }

  prevStep () {
    this.props.completoPrevStep()
  }

  resetStep () {
    this.props.icompletoResetStatus()
    this.props.setActualizarPresunta(false)
    this.props.destroy()
  }

  handleSubmit () {
    this.props.finalizarIngresoCompleto()
    this.props.setActualizarPresunta(false)
    this.props.destroy()
  }

  render () {
    const {
      iCompletoStep,
      numero
    } = this.props

    return (
      <div className='camiones-ingreso-completo-container'>
        <ModalSinCupo numero={numero} />
        {/* <h2>Actualización | Ingreso completo</h2> */}
        <h2>Ingreso completo</h2>
        {iCompletoStep === 0 && <IngresoCompleto0 onSubmit={this.nextStep} />}
        {iCompletoStep === 1 &&
          <IngresoCompleto1 onSubmit={this.nextStep} onPrev={this.resetStep} />}
        {iCompletoStep === 2 &&
          <IngresoCompleto2 onSubmit={this.nextStep} onPrev={this.prevStep} />}
        {iCompletoStep === 3 &&
          <IngresoCompleto3 onSubmit={this.handleSubmit} onPrev={this.prevStep} />}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    actualizarPresunta: state.camionesIngreso.actualizarPresunta,
    iCompletoStep: state.camionesIngreso.iCompletoStep,
    numero: selector(state, 'numero'),
    codigoCupo: selector(state, 'codigoCupo'),
    iCompletoCpa: state.camionesIngreso.iCompletoCpa
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({
    form: FORM_INGRESO_COMPLETO
  })(IngresoCompleto)
)
